import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { User } from '../entities/user';
import { HttpHeaders, HttpParams } from '@angular/common/http';
 

@Injectable()
export class UserService {
    constructor(private http: ApiService) { }
 

    register(user: User){
       const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json', 'No-Auth': 'True' });
    // return this.apiService.post('api/users', null,  { headers: reqHeader });
        return this.http.post2(`/api/users/register`, user, { headers: reqHeader });
    }

    registerConfirm(confirmCode){
         return this.http.post2(`/api/users/registerConfirm`, confirmCode);
     }

    updateLoginInfo(user: any){
        return this.http.post2(`/api/users/loginUpdate`, user);
    }


    callWSConnectRestAPI(msg: any){
        // const reqHeader = new HttpHeaders({ 'username': 'test4', 'No-Auth': 'True' });
        return this.http.post2(`/api/ws/rest/user-connect`, msg);
    }
    callWSDisConnectRestAPI(msg: any){
        return this.http.post2(`/api/ws/rest/user-disconnect`, msg);
    }
}